import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SearchFilterService {
  private http = inject(HttpClient);

  getSearchedObject(
    objectTip: string,
    searchKey: string,
    filters: object,
    offset: number,
    token: string = null
  ): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'en-namespace': environment.namespace,
      }),
    };
    let searchPayload = {
      objectTip,
      searchKey,
      filters,
      offset,
    };
    if (token) {
      searchPayload = { ...searchPayload, ...{ token } };
    }
    const url = `${environment.externalServiceUrl}search`;
    return this.http
      .post(url, searchPayload, httpOptions)
      .pipe(catchError((err) => of(null)));
  }
}
